/* eslint-disable no-bitwise */
/**
 * If input value resides betweeen 0 to 15, random hexadecimal value below 16 is returned.
 * If input value is greater than 15, returns the hexadecimal value of input.
 * Otherwise a 10 digit string is returned with random hex digits
 *
 *
 */
export const generateUUID = (input = '') => {
    const decimal = Number(input);
    return decimal >= 0
        ? (decimal ^ ((Math.random() * 16) >> (decimal / 4))).toString(16)
        : `${1e9}`.replace(/[018]/g, generateUUID);
};
export default generateUUID;
//# sourceMappingURL=generateUUID.js.map